import { gql } from '@apollo/client';

export default gql`
  query getBulkVouchersMetadata($serviceNumber: String!, $travelDate: String!) {
    getBulkVouchersMetadata(serviceNumber: $serviceNumber, travelDate: $travelDate) {
      status
      serviceNumber
      travelDate
      createdOn
      processedOn
      voucherType
      compensationPercentage
      selectedTotalPriceAmount {
        currency
        amount
      }
      ignoredTotalPriceAmount {
        currency
        amount
      }
      selectedTotalCount
      ignoredTotalCount
      selectedFile
      ignoredFile
      successFile
      failedFile
      successTotalCount
      failedTotalCount
    }
  }
`;
